import React, { FC, useCallback, useEffect, useState } from 'react';

import { useRouter } from 'expo-router';
import { StoreLocatorLoader } from 'features/store/components/store-locator-empty-states/look-animation';

import ActionButton from 'components/action-button';
import { getStaticPathname } from 'navigation/location/location';
import LoyaltyLoader from 'pages/loyalty/loyalty-loader/loyalty-loader';
import { t } from 'state/intl/translations';
import { routes } from 'utils/routing';

import { BodyText, HeadingText, Wrapper } from './styles';
import { ILocationEmptyState } from './types';

export const LocationEmptyState: FC<React.PropsWithChildren<ILocationEmptyState>> = ({
  title,
  message,
  onPress,
}) => {
  const [showLoading, setShowLoading] = useState(true);
  const router = useRouter();
  const handlePress = useCallback(() => {
    router.navigate({
      pathname: routes.storeLocator,
      params: {
        redirectUrl: getStaticPathname(),
      },
    });
  }, [router]);

  // there is a slight delay in modals showing up, show a loading rather than the full contents during this time
  useEffect(() => {
    setTimeout(() => {
      setShowLoading(false);
    }, 250);
  }, []);

  if (showLoading) {
    return <LoyaltyLoader />;
  }

  return (
    <Wrapper>
      <StoreLocatorLoader />
      <HeadingText>{title}</HeadingText>
      <BodyText>{message}</BodyText>
      <ActionButton onPress={onPress ?? handlePress} maxWidth={'$96'}>
        {t('selectLocation')}
      </ActionButton>
    </Wrapper>
  );
};
